// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3YKLv","badges":"styles_badges__2Cyhj"};